// Set or reset one user's password.
//
// ONE ACT, whether the account is new to a password or not — "set" and "reset" differ
// only in the story around them, never in what is written. Its own dialog rather than a
// field on the edit form, because resetting somebody's credentials should be something
// you chose, not something that happened while you were fixing a typo in their name.
//
// It does NOT end the user's sessions, and that is deliberate: a partner changing their
// own password would otherwise log themselves out mid-action, and a reset is usually
// because somebody forgot theirs rather than because the account is compromised. Where a
// session genuinely must die, that is deactivation — which does end them.
import { useState } from 'react';
import he from '../../i18n/he';
import { usersAdminApi } from '../../api';
import Modal from '../../components/Modal';
import { TextInput } from '../../components/Form';
import { ErrorText } from '../../components/Loader';

const MIN_PASSWORD = 8;

export default function PasswordModal({ user, onClose, onSaved }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const submit = async () => {
    try {
      await usersAdminApi.setPassword(user.id, password);
      onSaved();
    } catch (e) {
      setError(e);
    }
  };

  return (
    <Modal
      title={he.users.setPasswordTitle(user.name)}
      onClose={onClose}
      onSave={submit}
      saveLabel={he.users.setPassword}
      saveDisabled={password.length < MIN_PASSWORD}
    >
      <TextInput
        label={he.users.password}
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      {/* The rule is stated rather than enforced silently: the server refuses a short
          password too, so a form that only greyed out Save would be hiding the reason. */}
      <p className="muted small-note">{he.users.passwordHint}</p>
      {error && <ErrorText error={error} />}
    </Modal>
  );
}
